
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Check } from "lucide-react";

export const YouthRegulations = () => {
  return (
    <RegulationItem 
      value="youth" 
      icon={Check}
      title="Youth Regulations"
    >
      <ul className="list-disc pl-5 text-tribal-neutral">
        <li>Children under 14: No permit required.</li>
        <li>Children 14 and older: Permit required.</li>
      </ul>
    </RegulationItem>
  );
};
